export const GET_ALL_TIIE_ERROR = 'GET_ALL_TIIE_ERROR'
export const GET_ALL_TIIE_REQUEST = 'GET_ALL_TIIE_REQUEST'
export const GET_ALL_TIIE_SUCCESS = 'GET_ALL_TIIE_SUCCESS'
